import React, { useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { MiniButton } from '../ui/inputs/MiniButton/MiniButton';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props extends GridCellProps {
  keywordById: { [key: number]: Keyword };
  groupByParent: boolean;
}

const KeywordsCell: React.FC<Props> = ({ dataItem, keywordById, groupByParent, ...props }) => {
  const { t, i18n } = useTranslation();
  const keywordIds: number[] = dataItem.keyword_ids;
  let renderParent: boolean;
  let lastParent: string;

  const [expanded, setExpanded] = useState(false);

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      style={props.style}
    >
      <div className="my-2">
        {keywordIds.slice(0, expanded ? keywordIds.length : 1).map((keywordId: number, index) => {
          const keyword = keywordById[keywordId];

          if (keyword.parent_id) {
            const parent = keywordById[keyword.parent_id];
            renderParent = groupByParent && lastParent != parent.name;
            lastParent = parent.name;

            return (
              <div key={index}>
                {renderParent && <p className="font-semibold mt-2">{parent.name}</p>}
                <ul className="ml-4">
                  <li className="list-disc">{keyword.name}</li>
                </ul>
              </div>
            );
          }
        })}

        {keywordIds.length > 1 && (
          <StyledMinibuttonWrapper>
            <MiniButton
              labelText={expanded ? t('Show less') : t('Show more')}
              onButtonClick={() => setExpanded((prev) => !prev)}
            />
          </StyledMinibuttonWrapper>
        )}
      </div>
    </td>
  );
};

const StyledMinibuttonWrapper = styled.div`
  margin-top: 0.5rem;

  button {
    margin-left: 0 !important;
  }
`;

export default KeywordsCell;
